var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEdit = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22954",
    "data-name": "Path 22954",
    d: "M689.867,374.814l-.709-.707a2.85,2.85,0,0,0-2.018-.84,2.906,2.906,0,0,0-2.034.839l-10.775,10.769a.752.752,0,0,0-.195.331l-1.417,5.112a.754.754,0,0,0,.525.92.7.7,0,0,0,.4,0l5.122-1.417a.75.75,0,0,0,.331-.195l10.774-10.767A2.9,2.9,0,0,0,689.867,374.814Zm-15.342,14.626.732-2.648,1.915,1.916Zm12.493-9.853-8.425,8.418-2.637-2.634.189-.187,8.422-8.418L687.2,379.4ZM688.8,377.8h0l-.536.537-2.635-2.633.533-.535a1.366,1.366,0,0,1,1.906-.021l.731.729A1.377,1.377,0,0,1,688.8,377.8Z",
    transform: "translate(-672.693 -373.268)",
    fill: "#95A1B2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.36803039.svg";
export { ForwardRef as ReactComponent };